<div fxLayout="row wrap">
    <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <mat-card style="height: 70px">
            <mat-card-content>
                <mat-card-title class="text-muted m-0">{{ title }}</mat-card-title>
            </mat-card-content>
        </mat-card>
    </div>
</div>
